import { cn as merge } from "cn";
import { defineConfig } from "cva/config";

export const { cva, cx: cn } = defineConfig({ cx: merge });

export type { VariantProps } from "cva";
